// extracted by mini-css-extract-plugin
module.exports = {"taskDetailsCell":"style_taskDetailsCell__3-XvW","blockIcon":"style_blockIcon__3VWIF","cell":"style_cell__1Xast"};